// extracted by mini-css-extract-plugin
export default {"table":"DynamicTable_table__gx95x","img":"DynamicTable_img__sRf0r"};